import { Spinner as HeroSpinner } from '@heroui/react';

/** Inline loading spinner with an optional label. */
export function Spinner({ label, size = 'md', className }: { label?: string; size?: 'sm' | 'md' | 'lg'; className?: string }) {
  return <HeroSpinner label={label} size={size} color="primary" className={className} />;
}

/** Centered full-area spinner for route/section loading. */
export function LoadingScreen({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex min-h-[40vh] items-center justify-center" role="status" aria-live="polite" aria-busy="true">
      <HeroSpinner label={label} color="primary" />
    </div>
  );
}
